import { render, staticRenderFns } from "./articleChoose.vue?vue&type=template&id=008eef31&scoped=true"
import script from "./articleChoose.vue?vue&type=script&lang=js"
export * from "./articleChoose.vue?vue&type=script&lang=js"
import style0 from "./articleChoose.vue?vue&type=style&index=0&id=008eef31&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008eef31",
  null
  
)

export default component.exports